Element.prototype.formula = function(callback,MathJax2) {
    // این همان تابعی است که فانکشن ست کردن فرمول صدا میکند در فایل تاینی فرمول 
    // debugger;
    if (!this.dataset.code)
        return this;
    const code = this.dataset.code;
    this.classList.add('formula');
    this.classList.add('mceNonEditable');
    this.setAttribute('contenteditable', 'false');
    this.dataset.code = code;
    this.style.direction = 'ltr';
    this.style.display = 'inline-block';
    this.innerText = '`' + code + '`';
    if (callback === false)
        return this;

    MathJax2 = MathJax2==null ? window.MathJax : MathJax2;
    window.MathJax = MathJax2 ;
    MathJax2.Hub.Queue( 
        ['Typeset', MathJax2.Hub, this],
        () => {
            this.setAttribute('rendered', true);
            this.querySelectorAll('span').forEach(
                span => {
                    if (span.innerHTML === '')
                        span.innerHTML = '<span style="display: none">&nbsp;</span>';
                }
            );
            this.querySelectorAll('*[id^=MathJax-]').forEach(element => element.id = '');
        },
        callback,
    );
    return this;
};
